import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { FileDropDirective } from 'shared/util-common';

import { IconDirective } from '../icon/icon.directive';

@Component({
  selector: 'add-literature',
  standalone: true,
  imports: [TranslocoModule, MatIconModule, IconDirective, FileDropDirective],
  templateUrl: './add-literature.component.html',
  styleUrls: ['./add-literature.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddLiteratureComponent {
  @Input() public file?: File;
  @Output() public fileAdded = new EventEmitter<File>();
  @ViewChild('fileInput') public fileInput: ElementRef;
  @ViewChild('dropZone') public dropZone: ElementRef;

  protected onFileChange(file: File) {
    this.file = file;
    this.fileAdded.emit(this.file);
  }

  protected delete() {
    this.file = null;
    this.fileInput.nativeElement.value = '';
    this.dropZone.nativeElement.style.borderStyle = 'dashed';
  }

  protected allowedTypes: string[] = ['.bib', '.ris'];
}
